import { RootState } from '../../main/store/main.store.ts';

import { Profile } from '../slices/accounts/accounts.slice.types.ts';

export const selectProfile = (state: RootState): Profile | undefined => state.accounts.currentProfile;
